var sliders = {
	selectors: { },
	sliderInstances: [],

	init: function () {
		var self = this;

		self.tilesSlider();
		self.contentSlider();
		self.addedTilesSlider();
		self.responseGallery();
	},

	resetSliders: function() {
		var self = this;
		console.log( self.sliderInstances );

        // Iterate over all stored slider instances and destroy them
        self.sliderInstances.forEach(function(slider) {
            slider.destroy();
        });
        self.sliderInstances = []; // Reset the slider instances array
    },


	initializeResponseGallery: function() {
		var self = this;
        var slidersToInit = jQuery('.article-gallery__inner:not(.tns-slider), .woocommerce-product-gallery__wrapper:not(.tns-slider)');
        slidersToInit.each(function() {
            let slider = tns({
                container: this,
                items: 1,
                slideBy: 'page',
                gutter: 20,
            });
            self.sliderInstances.push(slider); // Store each initialized slider instance
        });
    },

    responseGallery: function() {
        var self = this;
		
        if (window.innerWidth <= 1023 && self.sliderInstances.length === 0) {
            self.initializeResponseGallery();
        }

        window.addEventListener('resize', function() {
            const screenWidth = window.innerWidth;

            if (screenWidth <= 1023 && self.sliderInstances.length === 0) {
                self.initializeResponseGallery();
            } else if (screenWidth > 1023 && self.sliderInstances.length > 0) {
               	self.resetSliders();
            }
        });
    },


	tilesSlider: function() {
		if( ! jQuery( '.js-tilesSlider' ).length ) {
			return false;
		}

		jQuery( '.js-tilesSlider:not(.tns-slider)' ).each(function() {
			var dataCount = jQuery( this ).attr( 'data-count' );
			dataCount = typeof dataCount !== 'undefined' && dataCount !== false ? dataCount : 5;


			let firstHalf = 2;
			let secondaHalf = 3;
			let thirdHalf = parseInt( dataCount ) - 1;
			let fourthHalf =  parseInt( dataCount );
			if (document.querySelector('.article-layout--post aside') ) {
				firstHalf = 2.5;
				secondaHalf = 2.5;
				thirdHalf = 2.5;
				fourthHalf = 2.5;
			}

			var slider = tns({
				container: this,
				items: 1,
				autoplay: false,
				loop: false,
				mouseDrag: true,
				controls: true,
				nav: false,
				slideBy: 'page',
				responsive: {
					768: {
						'items': firstHalf,
					},
					1024: {
						'items': secondaHalf,
					},
					1280: {
						'items': thirdHalf,
					},
					1920: {
						'items': fourthHalf,
					}
				}
			});
		});
	},

	contentSlider: function() {
		if( ! jQuery( '.js-contentTilesSlider' ).length ) {
			return false;
		}
		
		jQuery( '.js-contentTilesSlider:not(.tns-slider)' ).each(function() {

			let firstHalf = 2;
			let secondaHalf = 3;
			let thirdHalf = 4;
			let fourthHalf =  5;
			if (document.querySelector('.article-layout--post aside') ) {
				firstHalf = 2.5;
				secondaHalf = 2.5;
				thirdHalf = 2.5;
				fourthHalf = 2.5;
			}


			var slider = tns({
				container: this,
				items: 1,
				autoplay: false,
				loop: false,
				mouseDrag: true,
				controls: true,
				nav: false,
				slideBy: 'page',
				responsive: {
					768: {
						'items': firstHalf,
					},
					1024: {
						'items': secondaHalf,
					},
					1280: {
						'items': thirdHalf,
					},
					1920: {
						'items': fourthHalf,
					}
				}
			});
		});
	},

	addedTilesSlider: function() {
		if( ! jQuery( '.js-addedTilesSlider ul.products' ).length ) {
			return false;
		}
		
		jQuery( '.js-addedTilesSlider ul:not(.tns-slider)' ).each(function() {
			var slider = tns({
				container: this,
				items: 1,
				autoplay: false,
				loop: false,
				mouseDrag: true,
				controls: true,
				nav: false,
				slideBy: 'page',
				responsive: {
					576: {
						'items': 2,
					},
					992: {
						'items': 3,
					}
				}
			});
		});
	},


	

};

export { sliders };